import { FC, useEffect } from 'react';
import { VStack, Button } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { CreateCardDeckServerData } from '@olagg/db-types';
import OlaggForm from '../../../components/Forms/OlaggForm';
import OlaggFormInput from '../../../components/Forms/OlaggFormInput';
import { formServerSchema } from '@olagg/validation-schemas/cardDecks.schemas';
import { yupResolver } from '@hookform/resolvers/yup';

interface ServerFormProps {
  onSubmit: (dataForm: CreateCardDeckServerData) => void;
  server?: CreateCardDeckServerData;
}

const ServerForm: FC<ServerFormProps> = ({ onSubmit, server }) => {
  const useFormMethods = useForm<CreateCardDeckServerData>({
    resolver: yupResolver(formServerSchema),
    mode: 'onChange',
  });

  useEffect(() => {
    if (server) {
      useFormMethods.reset(server);
    }
  }, [server]);

  return (
    <OlaggForm
      useFormMethods={useFormMethods}
      onSubmit={onSubmit}
      style={{
        width: '100%'
      }}
    >
      <VStack spacing={4} maxW='600px' margin='0 auto'>
        <OlaggFormInput
          label='ID del server'
          controlName='serverId'
          required={true}
        />

        <OlaggFormInput
          label='Invite URL'
          controlName='inviteUrl'
          required={true}
        />

        <Button
          variant={'filledGradient'}
          type="submit"
          w={'full'}
          style={{
            marginTop: '30px'
          }}
        >
          Guardar
        </Button>
      </VStack>
    </OlaggForm>
  );
};

export default ServerForm; 